import React, { useEffect, useState } from "react"
import Layout from "../layout"
import SEO from "../components/seo"
import Paket from "../components/paket"
import PaketMC from "../components/paketMC"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlusSquare } from "@fortawesome/free-solid-svg-icons"
import { faMinusSquare } from "@fortawesome/free-solid-svg-icons"
import { useStaticQuery, Link } from "gatsby"
import { BookingButton } from "../components/atoms/Button"
import { Order } from "../components/formPage/FormPage"
import PriceTabSwitcher from "../components/pricePage/PriceTabSwitcher"
import KampanjMoped from "../components/kampanj/KampanjMoped"
import styles from "./priser.module.css"

const query = graphql`
  query {
    allPrismicPackage(filter: {}, sort: { fields: first_publication_date }) {
      edges {
        node {
          dataRaw
          id
        }
      }
    }
    allPrismicNyheterstartsida {
      edges {
        node {
          dataRaw
        }
      }
    }
    allPrismicPricebox {
      edges {
        node {
          dataRaw
        }
      }
    }
  }
`

// load from file in data folder
const bil2 = require("../data/bilProducts.json")
const mc2 = require("../data/mcProducts.json")

const Priser = ({ location }) => {
  const { allPrismicPricebox } = useStaticQuery(query)

  const priceBox = allPrismicPricebox.edges[0].node.dataRaw
  const [currentTab, setCurrentTab] = useState(location.state?.page || "CAR")
  const [items, setItems] = useState([])
  const [isCar, setIsCar] = useState(false)

  useEffect(() => {
    setIsCar(false)
  }, [currentTab])

  const addItem = item => {
    setItems(() => {
      const newItems = [...items, item]
      return newItems
    })
  }

  const removeItem = index => {
    setItems(() => {
      const newItems = items.filter((item, ind) => {
        return index !== ind
      })
      return newItems
    })
  }

  const transformItemsToBooking = () => ({
    orderState: {
      items,
    },
    orderType: Order.CART,
    car: isCar,
  })

  return (
    <Layout>
      <SEO title="Priser" />
      <div
        style={{
          backgroundColor: "#FAFAFA",
          padding: "0",
          color: "#666",
        }}
      >
        <br />
        <h2 className="cen">Våra priser</h2>
        <p style={{ padding: "0 2em" }}>
          På denna sida kan du läsa om våra nuvarande priser för paket och
          lektioner. Genom att klicka och addera ihop artiklar kan du se ett
          beräknat pris för din utbildning nere i rutan till höger.
          {/* <i style={{ fontWeight: "bold", marginLeft: 8 }}>
            Ny prislista nedan gäller från och med 20/1/2022
          </i> */}
        </p>

        <PriceTabSwitcher active={currentTab} onSwitch={setCurrentTab} />

        {currentTab === "CAR" && (
          <section>
            <Paket
              data={bil2}
              addItem={item => {
                addItem(item)
                setIsCar(true)
              }}
            />
            <br />
            <h2 className="cen">Priser - Bil</h2>
            <ul
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-around",
                backgroundColor: "white",
                margin: "0",
                color: "#222",
              }}
            >
              {bil2.map((item, index) => (
                <li
                  className={`listItem is-mobile hoverStyle`}
                  style={{ width: "100%", margin: "0", padding: "0.35em" }}
                  onClick={() => {
                    addItem({
                      title: item.descriptionHeader,
                      sub: item.descriptionHeader,
                      price: item.masterPrice,
                      vat: item.masterVat,
                      id: item.sellerArticlePackageMasterId,
                    })
                    setIsCar(true)
                  }}
                  key={item.sellerArticlePackageMasterId}
                >
                  <div className="flex-1 p-2">
                    <strong>{item.descriptionHeader}</strong>
                  </div>
                  <div className="flex-1 column is-one-third">
                    {item.descriptionHeader}
                  </div>
                  <div
                    className="flex-1 is-one-fifth"
                    style={{ textAlign: "right" }}
                  >
                    {item.masterPrice} kr
                  </div>
                  <div className="flex justify-center w-8">
                    <FontAwesomeIcon
                      className="hoverStyle"
                      icon={faPlusSquare}
                    />
                  </div>
                </li>
              ))}
            </ul>
          </section>
        )}

        {currentTab === "MC" && (
          <section>
            <PaketMC data={mc2} addItem={item => addItem(item)} />
            <br />
            <h2 className="cen">Priser - MC</h2>
            <ul
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-around",
                backgroundColor: "white",
                margin: "0",
                color: "#222",
              }}
            >
              {mc2.map((item, index) => (
                <li
                  className={`listItem is-mobile hoverStyle`}
                  style={{ width: "100%", margin: "0", padding: "0.35em" }}
                  onClick={() => {
                    addItem({
                      title: item.descriptionHeader,
                      sub: item.descriptionHeader,
                      price: item.masterPrice,
                      vat: item.masterVat,
                      id: item.sellerArticlePackageMasterId,
                    })
                    setIsCar(true)
                  }}
                  key={item.sellerArticlePackageMasterId}
                >
                  <div className="flex-1 p-2">
                    <strong>{item.descriptionHeader}</strong>
                  </div>
                  <div className="flex-1 column is-one-third">
                    {item.descriptionHeader}
                  </div>
                  <div
                    className="flex-1 is-one-fifth"
                    style={{ textAlign: "right" }}
                  >
                    {item.masterPrice} kr
                  </div>
                  <div className="flex justify-center w-8">
                    <FontAwesomeIcon
                      className="hoverStyle"
                      icon={faPlusSquare}
                    />
                  </div>
                </li>
              ))}
            </ul>
          </section>
        )}
        {currentTab === "MOPED" && (
          <>
            <KampanjMoped
              amPaket={mc2.find(p => p.sellerArticlePackageMasterId === 10474)}
              data={priceBox.mopedkurs}
            />
            <section
              className={`mx-auto max-w-2xl mt-12 px-6 ${styles.mopedContent}`}
            >
              <h2>Så kan din mopedutbildning se ut hos oss 🛵</h2>

              <h3>Helg – Teori & manövrering</h3>

              <h4>Lördag</h4>
              <ul>
                <li>Teori: 08:00 – 11:00</li>
                <li>Lunch: 11:00 – 12:00</li>
                <li>Teori: 12:00 – 15:00</li>
                <li>Manövrering: 15:30 – 17:30</li>
              </ul>

              <h4>Söndag</h4>
              <ul>
                <li>Teori: 08:00 – 12:00</li>
                <li>Lunch: 12:00 – 13:00</li>
                <li>Manövrering: 13:30 – 15:30</li>
              </ul>

              <p>
                Vi genomför teori och manövrering på helger (även under röda
                dagar och skollov).
              </p>

              <h3>Körning i trafik</h3>
              <p>
                Körning i trafik sker på vardagar (måndag–fredag) mellan 08:00
                och 16:00. Det kan därför ibland behövas att du är ledig från
                skolan för att genomföra körningen i trafik. Självklart gör vi
                alltid vårt bästa för att anpassa tiderna efter dina möjligheter.
              </p>

              <h3>Nya regler för mopedutbildning (AM-körkort)</h3>
              <p>
                Från 1 februari 2026 gäller nya regler för AM-utbildning i
                Sverige.
              </p>
              <ul>
                <li>Utbildningen ska vara minst 17 timmar totalt.</li>
                <li>Minst 10 timmar teori och 7 timmar praktisk körning.</li>
                <li>
                  Hos oss får du en komplett och trygg utbildning med både teori
                  och praktisk körning.
                </li>
                <li>Utbildningen kan ske på moped klass I eller mopedbil.</li>
                <li>
                  Du måste ha körkortstillstånd innan den praktiska delen. Ansök
                  här:{" "}
                  <a
                    href="https://www.transportstyrelsen.se/korkortstillstand"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://www.transportstyrelsen.se/korkortstillstand
                  </a>
                </li>
                <li>
                  Den praktiska utbildningen kan starta från 14 år och 9 månader.
                </li>
                <li>
                  För att få körkort måste du fylla 15 år och klara teoriprovet
                  hos Trafikverket.
                </li>
              </ul>

              <p>
                ✅ Boka din mopedkurs hos oss och ta första steget mot ditt
                AM-körkort! 🚦
              </p>
            </section>
          </>
        )}

        <div
          style={{
            position: "fixed",
            right: "0px",
            bottom: "2em",
            background: "white",
            padding: "1em",
            border: "1px solid #eee",
            borderRight: "0",
            borderRadius: "8px 0 0 8px",
            opacity: "0.9",
            color: "white",
            backgroundColor: "#333",
            zIndex: "100000",
            fontSize: "1em",
            textAlign: "right",
          }}
        >
          <ul
            style={{
              display: "flex",
              flexDirection: "column",
              textAlign: "right",
              alignContent: "stretch",
            }}
          >
            {items.map((item, index) => (
              <li
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-around",
                  width: "100%",
                }}
              >
                <p style={{ margin: "0", width: "120px", fontSize: "0.8em" }}>
                  {item.title}
                </p>
                <FontAwesomeIcon
                  style={{ margin: "0 0.4em" }}
                  icon={faMinusSquare}
                  onClick={() => removeItem(index)}
                />
              </li>
            ))}
          </ul>

          <h6 style={{ userSelect: "none", fontSize: "1.2em", color: "#AAA" }}>
            Totalt:{" "}
            <span style={{ fontSize: "1.2em", color: "#FFF" }}>
              {items && items.reduce((sum, item) => sum + item.price, 0)} kr
            </span>
            <Link to={"/formular"} state={transformItemsToBooking()}>
              <div
                css={BookingButton}
                style={{ margin: "16px", float: "right" }}
              >
                Boka!
              </div>
            </Link>
          </h6>
        </div>
        <br />
      </div>
    </Layout>
  )
}

export default Priser
